import { SafeResourceUrl } from '@angular/platform-browser';

export interface INgxGalleryOrderedImage {
  src: string | SafeResourceUrl;
  index: number;
  type: string;
}

export class NgxGalleryOrderedImage implements INgxGalleryOrderedImage {
  src: string | SafeResourceUrl;
  type: string;
  index: number;

  constructor(obj: INgxGalleryOrderedImage) {
    this.src = obj.src;
    this.index = obj.index;
    this.type = obj.type;
  }
}
